import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_FOLDERS_DEFAULT,
  PATH_FOLDERS_NEW,
} from '../../app/constants/paths.constant';
import { FolderForm } from '../../forms/Folder';
import { FormVariant } from '../../forms';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewFolderPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Folders);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'un Dossier")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_FOLDERS_DEFAULT,
            label: 'dossiers',
            key: 'folders',
          },
          {
            to: PATH_FOLDERS_NEW,
            label: 'nouveau',
            key: 'newFolder',
          },
        ]}
      />
      <PageTitle title="Création d'un Dossier" />
      <FolderForm formVariant={FormVariant.Creation} showCancelButton={false} />
    </>
  );
};
